import { Injectable } from '@angular/core';
import { ConfigProvider } from '../config/config';
import { AppState } from '../../config/state';
import { ViewController } from 'ionic-angular';

declare let gtag: Function;

@Injectable()
export class AnalyticsProvider {

  tracker: any;
  enabled: Boolean;

  constructor(private state: AppState, private config: ConfigProvider) {}

  initAnalytics() {
    this.config.load(this.state.appId).then( cfg => {
      if(cfg.settings && cfg.settings.GoogleAnalytics) {
        this.enabled = true;

        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date().getTime();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

        window['ga']('create', cfg.settings.GoogleAnalytics, {
          storage: 'none',
          clientId: localStorage.getItem('ga:clientId')
        });
        window['ga']('set', 'checkProtocolTask', null);
        window['ga']('set', 'checkStorageTask', null);
        window['ga']('set', 'appName', 'Communico App');
        window['ga']('set', 'anonymizeIp', true);
        window['ga']( (tracker) => {
          console.log('Google Analytics Enabled');
          localStorage.setItem('ga:clientId', tracker.get('clientId'));
          this.tracker = tracker;
          this.tracker.send('pageview', {
            title: 'home',
            page: 'home',
            hitCallback:function(){
              console.log("(Analytics) Page view: ", 'home');
            }
          });
        });
      } else {
        this.enabled = false;
        console.log('Google Analytics Disabled');
      }
    });
    this.state.nav.viewDidEnter.subscribe( (view:ViewController) => {
      if(view.name !== 'ScreenPage') {
        this.trackPageView(view.name);
      }
    });
  }

  trackPageView(page: String) {
    if(this.enabled && this.tracker) {
      this.tracker.send('pageview', {
        title: page,
        page: page,
        hitCallback:function(){
          console.log("(Analytics) Page view: ", page);
        }
      });
    }
  }

  trackEvent(category: String, action: String, label?: String, value?: String) {
    if(this.enabled && this.tracker) {
      this.tracker.send('event', category, action, label, value, {
        hitCallback:function(){
          console.log(`(Analytics) Event: ${category} / ${action} / ${label} / ${value}`);
        }
      });
    }
  }

}


// WEBPACK FOOTER //
// ./src/providers/analytics/analytics.ts